import * as React from 'react';
import { CreateProduto } from '../../../components/product/create-form';

export const ProductForm = ({
  formState,
  tiposProdutos,
  onSave,
  onUpdate,
  onClose,
  onTitleChange,
  onUpdateChange,
  getImageBlob,
  showNotification,
  showModal,
}) => {
  const [formKey, setFormKey] = React.useState(0);

  const handleFormClose = React.useCallback(
    (isOpen) => {
      if (!isOpen) {
        onClose();
      }
    },
    [onClose],
  );

  const handleCallback = React.useCallback(() => {
    onUpdateChange(false);
    onTitleChange('Novo produto');
    setFormKey((key) => key + 1);
  }, [onTitleChange, onUpdateChange]);

  return (
    <CreateProduto
      key={formKey}
      setTitleFormProduto={onTitleChange}
      setIsFormProduto={handleFormClose}
      setIsUpdate={onUpdateChange}
      notify={showNotification}
      save={onSave}
      update={onUpdate(formState.produto?.id)}
      isUpdate={formState.isUpdate}
      productProps={formState.produto}
      openModal={showModal}
      typeProducts={tiposProdutos}
      callback={handleCallback}
      getFotoCapa={
        formState.isUpdate ? getImageBlob(formState.produto?.id, 'CAPA') : undefined
      }
      getFotoCard={
        formState.isUpdate ? getImageBlob(formState.produto?.id, 'CARD') : undefined
      }
    />
  );
};
